let authSessionId = 0;

export const bumpAuthSession = () => {
  authSessionId += 1;
  return authSessionId;
};

export const getAuthSession = () => authSessionId;

export const isCurrentAuthSession = (sessionId) => sessionId === authSessionId;

/** Remove legacy persisted user slice that can resurrect the previous account on rehydrate. */
export const clearPersistedUserState = () => {
  try {
    const raw = localStorage.getItem("persist:root");
    if (!raw) return;

    const parsed = JSON.parse(raw);
    delete parsed.user;
    localStorage.setItem("persist:root", JSON.stringify(parsed));
  } catch {
    // Ignore malformed persist payload
  }
};

const normalizeEmail = (email) => (email || "").trim().toLowerCase();

/** True when a fetched profile belongs to the account that just logged in. */
export const profileMatchesLoginEmail = (profile, loginEmail) => {
  const expected = normalizeEmail(loginEmail);
  if (!expected) return false;

  const candidates = [
    profile?.email,
    profile?.personalEmail,
    profile?.institutionalEmail,
  ].map(normalizeEmail);

  return candidates.includes(expected);
};

/** Reads userId from a JWT access token payload. */
export const getUserIdFromToken = (token) => {
  if (!token || typeof token !== "string" || token.split(".").length !== 3) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.userId || payload._id || null;
  } catch {
    return null;
  }
};
